import styles from './Hero.module.scss';
import NewsArrow from '../../../Icons/NewsArrow';
import React from 'react';
import { useMediaQuery } from 'usehooks-ts';

export default function NewsListHero({ fields }) {
  const data = fields.hero.fields.detail;

  const isMobile = useMediaQuery('(max-width: 480px)');
  const imageUrl = isMobile ? data.fields.mobileImage.value.src : data.fields.image.value.src;
  return (
    <div className={'container'}>
      <div className={styles.wrapper} style={{ backgroundImage: `url(${imageUrl})` }}>
        <div className={styles.content}>
          {/* <h3 className={styles.subtitle}>{data.fields.subtitle.value}</h3> */}
          <h1 className={styles.title}>{data.fields.title.value}</h1>
          <p className={styles.text}>{data.fields.date.value}</p>
          <a href={fields.hero.url} className={styles.more}>
            <span>{fields.readMoreText.value}</span>
            <NewsArrow width={14} height={14} strokeWidth={2} />
          </a>
        </div>
      </div>
    </div>
  );
}
